// extracted by mini-css-extract-plugin
export default {"vehicle-info":"vehicle-info_vehicle-info__Olb5I","row":"vehicle-info_row__A0i1H"};